// PowerBIReportContent.jsx
import React, { useRef } from 'react';
import { Spin } from 'antd';
import { PowerBIEmbed } from 'powerbi-client-react';
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const PowerBIReportContent = ({
  loading,
  error,
  embedInfo,
  reportConfig,
  eventHandlers,
  isFullscreen,
  toggleFullscreen,
  cardRef,
  updateZoomWithDelay,
  fetchEmbedInfo
}) => {
  const reportRef = useRef(null);

  if (loading) {
    return (
      <div style={{ 
        height: '100%', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        flexDirection: 'column'
      }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>Carregando relatório...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        height: '100%', 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        flexDirection: 'column'
      }}>
        <div style={{ color: '#ff4d4f', marginBottom: '10px' }}>
          <h3>Erro ao carregar relatório</h3>
          <p>{error}</p>
        </div>
        <button 
          onClick={fetchEmbedInfo}
          style={{ 
            padding: '8px 16px',
            border: '1px solid #1890ff',
            borderRadius: '4px',
            background: '#1890ff',
            color: 'white',
            cursor: 'pointer'
          }}
        >
          Tentar novamente
        </button>
      </div>
    );
  }

  if (!loading && !error && embedInfo) {
    return (
      <>
        <button
          onClick={() => toggleFullscreen(cardRef.current)}
          title={isFullscreen ? 'Sair do modo tela cheia' : 'Entrar no modo tela cheia'}
          style={{
            position: 'absolute',
            top: '5px',
            left: '5px',
            zIndex: 1,
            background: 'transparent',
            border: 'none',
            borderRadius: '5px',
            padding: '5px',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
          }}
        >
          {isFullscreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
        </button>
        <div style={{ 
          height: '100%', 
          width: '100%', 
          overflow: 'hidden',
          position: 'relative',
          background: 'transparent',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}>
          <PowerBIEmbed
            embedConfig={reportConfig}
            eventHandlers={eventHandlers}
            cssClassName="report-style"
            getEmbeddedComponent={(embeddedReport) => {
              window.report = embeddedReport;
              reportRef.current = embeddedReport;
              if (cardRef.current) {
                updateZoomWithDelay(1000);
              }
            }}
          />
        </div>
      </>
    );
  }

  return null;
};

PowerBIReportContent.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.string,
  embedInfo: PropTypes.object,
  reportConfig: PropTypes.object,
  eventHandlers: PropTypes.array.isRequired,
  isFullscreen: PropTypes.bool.isRequired,
  toggleFullscreen: PropTypes.func.isRequired,
  cardRef: PropTypes.object.isRequired,
  updateZoomWithDelay: PropTypes.func.isRequired,
  fetchEmbedInfo: PropTypes.func.isRequired,
  windowWidth: PropTypes.number.isRequired
};

export default PowerBIReportContent;